<template>
    <v-card class="ma-2 card-schedule">
        <v-card-title class="card-schedule-title">
            Position
        </v-card-title>
        <v-card-text class="schedule-text-card">
            <template v-for="(position, id) in positions">
                <v-layout :key="id" row wrap justify-space-between>
                    <div class="employee-position-input">
                        <v-text-field v-model="position.name" @input="onPositionChange(position, id)" label="Position" class="input-card" maxlength="100" :disabled="!isEditEnabled"></v-text-field>
                    </div>

                    <div class="schedule-group">
                        <div class="center">Choose schedule of employees:</div>
                        <div class="employee-radiobutton">
                            <v-radio-group row v-model="position.schedule" @change="onPositionChange(position, id)">
                                <v-radio :disabled="!isEditEnabled" label="Fixed" value="fixed" color="indigo" class="fixed-radiobutton"></v-radio>
                                <v-radio :disabled="!isEditEnabled" label="Flexible" value="flexible" color="indigo"></v-radio>
                            </v-radio-group>
                        </div>
                    </div>

                    <div class="datapicker-wrapper">
                        <div class="datapicker-hiring">
                            <v-menu ref="menuHiring" lazy v-model="position.hiringPicker" transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false"
                                max-width="290px" min-width="290px">
                                <v-text-field slot="activator" label="Contract start" placeholder="Contract start" v-model="position.contractStart"
                                    prepend-icon="event" readonly class="add-employee-date" :disabled="!isEditEnabled" @input="onPositionChange(position, id)"
                                ></v-text-field>
                                <v-date-picker v-model="position.contractStart" no-title scrollable actions
                                     class="add-employee-date" :readonly="!isEditEnabled"
                                ></v-date-picker>
                            </v-menu>
                        </div>

                        <div class="datapicker-hiring">
                            <v-menu ref="`menuContract{id}`" lazy v-model="position.contractPicker" transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false"
                                max-width="290px" min-width="290px">
                                <v-text-field slot="activator" label="Contract lapse" placeholder="Contract lapse"
                                    v-model="position.contractLapse" prepend-icon="event" readonly :disabled="!isEditEnabled" @input="onPositionChange(position, id)"
                                ></v-text-field>
                                <v-date-picker v-model="position.contractLapse" no-title
                                    scrollable actions :readonly="!isEditEnabled"
                                ></v-date-picker>
                            </v-menu>
                        </div>

                        <div>
                            <v-menu ref="menuProbationDate" lazy v-model="position.probationPicker" transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false"
                                max-width="290px" min-width="290px">
                                <v-text-field slot="activator" label="Probation date" placeholder="Probation date"
                                    v-model="position.probationDate" prepend-icon="event" readonly class="add-employee-date" :disabled="!isEditEnabled" @input="onPositionChange(position, id)"
                                ></v-text-field>
                                <v-date-picker v-model="position.probationDate" no-title scrollable actions class="add-employee-date" :readonly="!isEditEnabled"
                                ></v-date-picker>
                            </v-menu>
                        </div>
                    </div>

                    <v-tooltip v-if="id === 0" bottom>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click="addPosition()" slot="activator" class="add-position-btn">
                            <v-icon small color="indigo">mdi-plus</v-icon>
                        </v-btn>
                        <div>Add new position</div>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                        <v-btn :disabled="!isEditEnabled" flat color="black" @click="removePosition(id)" slot="activator" class="add-position-btn">
                            <v-icon small color="indigo">mdi-minus</v-icon>
                        </v-btn>
                        <div>Remove position</div>
                    </v-tooltip>
                </v-layout>
            </template>
        </v-card-text>
    </v-card>
</template>
<script>
    import moment from 'moment';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'EmployeePosition',
        computed: {
            ...mapGetters({
                employeeProbationDate: 'getEmployeeProbationDate',
                employee: 'getEmployee',
                positions: 'getPositions'
            }),
            isEditEnabled() {
                return !this.employee.archived;
            }
        },
        methods: {
            ...mapActions([
                'editEmployeePosition',
                'addEmployeePosition',
                'removeEmployeePosition'
            ]),
            onPositionChange(value, index) {
                this.positions[index] = value;
                this.editEmployeePosition(this.positions);
            },
            addPosition() {
                this.addEmployeePosition();
            },
            removePosition(index) {
                this.removeEmployeePosition(index);
            },
            formatDate(date) {
                return moment(this.now).format('YYYY-MM-DD');
            }
        }
    };
</script>

<style scoped>
    .input-group.input-group--selection-controls.switch {
        max-width: fit-content;
        margin-right: 10px;
    }

    .center {
        align-self: center;
        font-size: 12px;
        font-weight: 500;
    }
    .datapicker-hiring,
    .datapicker-contract {
        width: 100%;
    }
    .employee-position-input {
        flex-grow: 1;
        margin-right: 35px;
        min-width: 200px;
    }
    .schedule-group {
        width: 200px;
        margin-top: -5px;
    }
    .datapicker-wrapper .input-group {
        width: 140px;
    }
    .datapicker-lapse {
        margin-right: -2px;
    }
    @media screen  and (max-width: 960px){
        .datapicker-wrapper .input-group--text-field {
            width: 100%;
        }
        .datapicker-wrapper {
            width: 100%;
            flex-direction: column;
        }

        .employee-position-input {
            margin-right: 0px;
            width: 100%;
        }

        .datapicker-hiring {
            margin-right: 15px !important;
        }
    }

    @media screen and (min-width: 600px) {
        .datapicker-wrapper {
            flex-direction: row;
        }
    }

    .schedule-group .input-group.radio-group {
        padding-top: 4px;
    }

    .datapicker-wrapper {
        display: flex;
        justify-content: flex-start;
    }

    .datapicker-hiring {
        margin-right: 15px;
    }
    .fixed-radiobutton {
        margin-right: -30px;
    }
    .add-position-btn >>> .btn__content {
        padding: 0;
    }
    .add-position-btn {
        min-width: 24px;
        width: 24px;
        min-height: 24px;
        height: 24px;
        margin: 6px 0px 14px 6px;
        background-color: #CED2E6 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeePosition.vue